import { useMemo } from "react";

import { ProductTab } from "@views/shared";

import { ClassroomUsers } from "./classroom-users";

export const ClassroomUsersTab = ({
  name,
  className,
  users: data,
  classroom,
  responsiveStyles,
  readOnly,
  onUsersUpdate,
  getUsers,
  openRosterModal,
  rosterModalOpened,
  statusFilter,
  onStatusFilterChange,
  loading,
}) => {
  const usersTabs = useMemo(() => {
    return classroom?.products?.reduce((acc, product) => {
      acc[product] = (
        <ClassroomUsers
          classroom={classroom}
          data={data}
          responsiveStyles={responsiveStyles}
          readOnly={readOnly}
          onUsersUpdate={onUsersUpdate}
          getUsers={getUsers}
          openRosterModal={openRosterModal}
          rosterModalOpened={rosterModalOpened}
          productId={product}
          statusFilter={statusFilter}
          onStatusFilterChange={onStatusFilterChange}
          loading={loading}
        />
      );
      return acc;
    }, {});
  }, [
    classroom,
    data,
    responsiveStyles,
    readOnly,
    onUsersUpdate,
    getUsers,
    openRosterModal,
    rosterModalOpened,
    statusFilter,
    onStatusFilterChange,
    loading,
  ]);

  return (
    <ProductTab
      name={name}
      className={className}
      productComponents={usersTabs}
    />
  );
};
